import api from './api';
export const ownerCardService = {
    // Dosya yükleme - ReactJS için uyarlanmış
    uploadOwnerCard: async (file) => {
        const formData = new FormData();
        formData.append('file', file); // ReactJS'de doğrudan file objesi kullanılır
        return api.post('/owner-cards/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    // Kartviziti getir
    getMyOwnerCard: async () => {
        return api.get('/owner-cards');
    },
    // Kartviziti sil
    deleteMyOwnerCard: async () => {
        return api.delete('/owner-cards');
    },
};